export interface FeatureFlag {
  _id: string;
  key: string;
  name: string;
  description?: string;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFeatureFlagPayload {
  key: string;
  name: string;
  description?: string;
  enabled?: boolean;
}

export interface UpdateFeatureFlagPayload {
  key?: string;
  name?: string;
  description?: string;
  enabled?: boolean;
}

export type ActiveFlagsMap = Record<string, boolean>;

/**
 * Centralized registry of all known feature-flag keys.
 * Mirrors the backend enum so both sides stay in sync.
 */
export enum FeatureFlagKey {
  // ── Odoo sync flags ──────────────────────────────────────────────────
  ENABLE_ODOO_CONTACT_SYNC = 'ENABLE_ODOO_CONTACT_SYNC',
  ENABLE_ODOO_ORGANIZATIONS_SYNC = 'ENABLE_ODOO_ORGANIZATIONS_SYNC',
  ENABLE_ODOO_LEGAL_ENTITIES_SYNC = 'ENABLE_ODOO_LEGAL_ENTITIES_SYNC',
  ENABLE_ODOO_PURCHASE_ORDERS_SYNC = 'ENABLE_ODOO_PURCHASE_ORDERS_SYNC',
  ENABLE_ODOO_BILLING_ORDERS_SYNC = 'ENABLE_ODOO_BILLING_ORDERS_SYNC',
  ENABLE_ODOO_PRODUCTS_SYNC = 'ENABLE_ODOO_PRODUCTS_SYNC',

  // ── Email flags ──────────────────────────────────────────────────────
  ENABLE_MARKETING_EMAILS = 'ENABLE_MARKETING_EMAILS',

  // ── UI visibility flags ──────────────────────────────────────────────
  SHOW_OPPORTUNITIES_VIEW = 'SHOW_OPPORTUNITIES_VIEW',
  SHOW_ACTIVITIES_VIEW = 'SHOW_ACTIVITIES_VIEW',
  SHOW_PRESALES_VIEW = 'SHOW_PRESALES_VIEW',
}
